export default __webpack_public_path__ + "34957b6e998339696eef3e7b4a69a402.webp";